<template>
  <div class="alert-wrapper">
    <b-alert
      :show="!!mensagem"  
      :variant="cor"       
      dismissible
      @dismissed="$emit('close')" 
      class="text-center custom-alert"
    >
      <span class="alert-text">{{ mensagem }}</span>
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {
    tipo: {
      type: String,
      default: 'msg' // 'msg' (verde), 'ale' (amarelo), 'err' (vermelho)
    },
    mensagem: {
      type: String,
      required: true
    }
  },
  computed: {
    cor() {
      return {
        msg: 'success',
        ale: 'warning',
        err: 'danger'
      }[this.tipo] || 'secondary';
    }
  }
};
</script>

<style scoped>
.alert-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.custom-alert {
  max-width: 600px;
  width: 100%;
  font-size: 1.2rem;
}

.alert-text {
  font-weight: 500;
}
</style>
